var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBanner)?_c('DelinquentBanner',{attrs:{"banner-type":_vm.bannerType,"banner-message":_vm.bannerMessage.body,"banner-title":_vm.bannerMessage.title}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }